<template>
    <div class="container">
        <div class="row">
            <div class="col-md-12">
                <h3 class="text-center">{{ 'Liste des sessions du thème «' + currentTemplateName + '»' }}</h3>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12">
                <div id="grid-container-grille-audit-list">
                    <div id="grilleAuditGrid__evolugrid_holder" style="position: relative">
                        <div id="grilleAuditGrid">
                            <table class="table table-hover">
                                <thead>
                                    <tr>
                                        <th>Session</th>
                                        <th>Actions</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="templateSession in auditTemplateSessions" :key="templateSession.id">
                                        <td>
                                            <router-link tag="a" :to="{name: 'SessionDetail', params: {templateId: currentTemplateId, sessionId: templateSession.id}}">
                                                {{ 'Session du ' + (templateSession.startAt ? formatDate(templateSession.startAt) : '-') + ' au ' + (templateSession.endAt ? formatDate(templateSession.endAt) : '-') + ' (' + templateSession.nbChildren + ' participant' + (templateSession.nbChildren == 1 ? ')' : 's)') }}
                                            </router-link>
                                        </td>
                                        <td>
                                            <router-link tag="button" class="btn btn-success" :to="{name: 'SessionReport', params: {templateId: currentTemplateId, sessionId: templateSession.id}}">
                                                Rapport
                                            </router-link>
                                            <a v-if="templateSession.hasReport && templateSession.hasFinishedChildren" target="_blank" :href="exportUrl(templateSession.id)" class="btn btn-success">Export PDF</a>
                                            <button v-if="templateSession.hasFinishedChildren" type="button" class="btn btn-success" @click="displayStatistics(templateSession.id)">Statistiques</button>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <modalStatisticsBlock v-if="modalSessionId" :group="true" :results="true" :satisfaction="true" :id="modalSessionId"></modalStatisticsBlock>
    </div>
</template>


<script>
    import ModalStatisticsBlock from 'components/ModalStatisticsBlock';

    export default {
        components: {
            ModalStatisticsBlock
        },
        computed: {
            currentTemplateId: function()   {
                return this.$route.params.templateId;
            },
            currentTemplateName: function() {
                return this.$store.state.admin.templateSessions[0] ? this.$store.state.admin.templateSessions[0].theme : ""; 
            },
            auditTemplateSessions: function() {
                return this.$store.state.admin.templateSessions;
            }
        },
        methods: {
            exportUrl(id)   {
                return this.$store.state.baseUrl + '/export/0/' + id + '?token=' + this.$store.state.token;
            },
            displayStatistics(sessionId) {
                this.modalSessionId = sessionId;
                this.$store.commit('DISPLAY_MODAL_STATISTICS', true);
            },
            formatDate(date)  {
                let d = new Date(date);
                return d.getDate().toString().padStart(2, "0") + '/' + (d.getMonth() + 1).toString().padStart(2, "0") + '/' + d.getFullYear() + ' - ' + d.getHours() + ':' + d.getMinutes().toString().padStart(2, "0");
            }
        },
        data: function()  {
            return {
                modalSessionId: 0
            };
        },
        beforeCreate()  {
            this.$emit('navbarUpdate', {
                backText: "Retour aux grilles d'audit",
                pathData: {
                    name: "TemplateList"
                }
            });
        }
    };
</script>

<style>


</style>
